import React, { useEffect, useState } from 'react';
import { Grid, Box, Typography, IconButton } from '@mui/material';
import { useDispatch, useSelector } from 'react-redux';
import { Nextstep } from './features/counterSlice';
import { updateScore } from './features/resultSlice';
import { saveApiData } from './features/qustionSlice';

function MainContent() {
  const apiData = useSelector((state) => state.questionResult.apiData);

  const [questiondata, setquestiondata] = useState({
    Tatal: 0,
    Listen_Que: [],
    Speek_Que: [],
    Read_Que: [],
    write_Que: []
  });

  const dispatch = useDispatch();

  useEffect(() => {
    // Get QuestionData from localStorage
    const data = JSON.parse(localStorage.getItem('QuestionData'));
    if (data) {
      setquestiondata(data);

      // Dispatch total question counts into Redux for each test category
      dispatch(updateScore({ testIndex: 0, rightAnswer: 0, wrongAnswer: 0, TotalQue: data.Listen_Que.length }));
      dispatch(updateScore({ testIndex: 1, rightAnswer: 0, wrongAnswer: 0, TotalQue: data.Speek_Que.length }));
      dispatch(updateScore({ testIndex: 2, rightAnswer: 0, wrongAnswer: 0, TotalQue: data.Read_Que.length }));
      dispatch(updateScore({ testIndex: 3, rightAnswer: 0, wrongAnswer: 0, TotalQue: data.write_Que.length }));

      // Optional — also dispatch to qustionSlice if you want
      dispatch(saveApiData(data));
    }
  }, [dispatch]); // Runs only once when component mounts

  const handleClick = () => {
    dispatch(Nextstep());
  };

  return (
    <Box>
      {/* Title */}
      <Box sx={{ display: 'flex', justifyContent: 'center', mb: 4 }}>
        <Typography className="pertext" variant="h6">PRE-ASSESSMENT TEST</Typography>
      </Box>

      {/* Test Icons */}
      <Grid container spacing={2} sx={{ mb: 4 }}>
        {['LISTENING TEST', 'SPEAKING TEST', 'READING TEST', 'WRITING TEST'].map((test, index) => (
          <Grid item xs={12} sm={6} md={3} key={index}>
            <Box textAlign="center">
              <Box
                component="img"
                src={`/images/Picture${index + 1}.png`}
                alt={`${test} Icon`}
                sx={{ width: '100%', maxWidth: 200, mb: 1 }}
              />
            </Box>
          </Grid>
        ))}
      </Grid>


      {/* Audio Button */}
      <Box mt={3} mb={10} textAlign="center">
        <IconButton
          onClick={handleClick}
          color="secondary"
          sx={{ padding: '10px 40px' }}
        >
          <img
            src="/images/Picture6.png"
            alt="Play audio"
            style={{ width: '200px', height: 'auto' }}
          />
        </IconButton>
      </Box>
    </Box>
  );
}

export default MainContent;
